{
  "SEARCH": {
    "TABS": {
      "ALL": "Alle",
      "CONTACTS": "Kontakter",
      "CONVERSATIONS": "Samtaler",
      "MESSAGES": "Messages"
    },
    "SECTION": {
      "CONTACTS": "Kontakter",
      "CONVERSATIONS": "Samtaler",
      "MESSAGES": "Messages"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Searching",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ to focus",
    "INPUT_PLACEHOLDER": "Type 3 or more characters to search",
    "RECENT_MESSAGES": "Mine nylig sendte meldinger",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Read more",
    "WROTE": "wrote:",
    "FROM": "fra",
    "EMAIL": "e-post",
    "EMAIL_SUBJECT": "subject"
  }
}
